import { render } from "./DetailsPayment.vue?vue&type=template&id=3e4a384d&scoped=true"
import script from "./DetailsPayment.vue?vue&type=script&lang=js"
export * from "./DetailsPayment.vue?vue&type=script&lang=js"

import "./DetailsPayment.vue?vue&type=style&index=0&id=3e4a384d&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4a384d"],['__file',"resources/js/pages/payments/DetailsPayment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e4a384d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e4a384d', __exports__)) {
    console.log('reload')
    api.reload('3e4a384d', __exports__)
  }
  
  module.hot.accept("./DetailsPayment.vue?vue&type=template&id=3e4a384d&scoped=true", () => {
    console.log('re-render')
    api.rerender('3e4a384d', render)
  })

}


export default __exports__